import * as yup from "yup";

export const validationSchema = yup.object().shape({
  surveyorName: yup.string(),
  liner: yup.string().required("Liner is required"),
  startDate: yup.string().required("Start Date is required"),
  endDate: yup.string().required("End Date is required"),
  isImmediate: yup.boolean(),
  surveyorId: yup.string().required("Surveyor is required"),
});